var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGrayLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-20 -20 559 370",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .contrast { fill: #c4cad3; }\r\n      .medium { fill: #a7b1be; }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_33",
    width: 559,
    height: 370,
    transform: "translate(-175)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_2",
    transform: "translate(175)",
    opacity: 0.75,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-174.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    className: "contrast",
    d: "M156.611,89.036c65.837,67.4,78.908,136.252,62.765,209.016-10.18,45.9,10.662,107.58,48.67,129.2L214.377,458.4c-50-31.744-68.608-90.353-56.682-133.542,16.143-59.211,8.072-135.048-48.73-191.729L59.09,82.169l19.094-71.5Z",
    transform: "translate(229.738 53.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    className: "contrast",
    d: "M341.316,165.907c13.553,13.553,81.8,58.85,81.8,58.85l-51.2,29.7L300.3,211.324c-43.008-29.154-73.427-79.631-208.173-122.519L19.84,10.5C186.692,25.86,297.766,122.3,341.316,165.907Z",
    transform: "translate(311.093 52.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    className: "medium",
    d: "M92.92,199.258,97.2,166.731l17.167-29.7,101.918-27.347,18.432-18.071,83.245-22.347L336.572,0l50.357,50.357-19.155,71.379-26.5-26.5L265.976,135.77a19.095,19.095,0,0,0-17.468,21.986Z",
    transform: "translate(-92.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    className: "medium",
    d: "M261.573,70.691,264.766,46.6,314.58,19.25l60.235,60.536c56.5,55.959,65.175,89.69,71.62,143.721L316.749,146.828l8.794-49.754-21.926,37.948-43.189,11.625L217.059,121.59,171.1,134l-35.6,24.7L79,119.361Z",
    transform: "translate(-68.579 96.703)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrayLeft);
export default __webpack_public_path__ + "static/media/logo_gray_left.bc729c3aed95b27f7ad499f3c4746807.svg";
export { ForwardRef as ReactComponent };